import { AnyID, Item, LinkedSonID, Node, Zone } from '@types'
import { Group, Mesh, Texture } from 'three'
import { ObjectGroup } from './ObjectGroupENC'
import { ObjectMesh } from './ObjectMeshENC'

// Interfaz para el resultado del análisis de muebles contiguos
interface ContiguousAnalysisResult {
  groups: object[][]
  totalGroups: number
  totalItemsInGroups: number
}

export type SceneObjectRendererProps = {
  object: Node
  zones: Zone
  morphs: Item['morphs']
  textures: Item['textures']
  renderTarget?: Texture
  childs?: Set<LinkedSonID>
  id?: AnyID
  paginaPdf?: number | undefined
  itemHeight?: number
  itemWidth?: number
  itemThickness?: number
  depth?: number
  getContiguousItems?: () => ContiguousAnalysisResult
  fatherId?: string
  universal?: boolean
}

export function SceneObjectRenderer({
  object,
  zones,
  morphs,
  textures,
  id,
  renderTarget,
  depth = 1,
  paginaPdf,
  itemHeight,
  itemWidth,
  itemThickness,
  getContiguousItems,
  fatherId,
  universal,
}: SceneObjectRendererProps) {
  return object?.children?.map((node: Node) => {
    if (node instanceof Group) {
      return (
        <group
          scale={depth}
          key={node?.uuid}
        >
          <ObjectGroup
            node={node}
            renderTarget={renderTarget}
            morphs={morphs}
            textures={textures}
            zones={zones}
            itemHeight={itemHeight}
            paginaPdf={paginaPdf}
            itemWidth={itemWidth}
            itemThickness={itemThickness}
            getContiguousItems={getContiguousItems}
            fatherId={fatherId}
            itemId={id ?? fatherId}
            universal={universal}
          />
        </group>
      )
    } else if (node instanceof Mesh) {
      return (
        <ObjectMesh
          key={node?.uuid}
          node={node}
          zones={zones}
          morphs={morphs}
          textures={textures}
          renderTarget={renderTarget}
          paginaPdf={paginaPdf}
          itemHeight={itemHeight}
          itemWidth={itemWidth}
          itemThickness={itemThickness}
          getContiguousItems={getContiguousItems}
          fatherId={fatherId}
          itemId={id ?? fatherId}
          universal={universal}
        />
      )
    }
  })
}
